import { render, staticRenderFns } from "./Horizontal-navbar.vue?vue&type=template&id=249dbd36&"
import script from "./Horizontal-navbar.vue?vue&type=script&lang=js&"
export * from "./Horizontal-navbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports